'use strict';

var _ = require('lodash');
var _require = require("../../../../v2/utils/constants"),
  FO_BENCHMARK_COMPONENTS = _require.FO_BENCHMARK_COMPONENTS;
var ConfigurationParametersControlTypeService = function ConfigurationParametersControlTypeService(momentService, featureToggleService, configurationService, conditionsAndActionsService, restangular) {
  var dropdownParameterNames = ['ROM_MAX_SELECT_ANALYSIS_WEEKS', 'FIM_INSTALLED', 'ROM_IS_MAPPED_AND_FIXED_ALLOC_INDICATOR', 'DISTANCE_UNIT', 'HONOR_MARRIED_SEGMENTS', 'OVERBOOKING_UPWARD_SPILL_MOVABLE', 'REGULAR_SET_ASIDE_ENABLED', 'LAST_SEAT_AVAILABLE_TO_LOCAL_SERVICE', 'USE_MWTP_FOR_MAPPED', 'OVERBOOKING_UPWARD_SPILL_FIXED', 'OVERBOOKING_MODEL', 'PRORATION_EMSR', 'PRORATION_DEMAND_WEIGHTED_CER', 'MAPPED_FORECASTING_CLASS_GROUPING_BY_CLASS', 'LOGICAL_PHYSICAL_CAP', 'OVERBOOKING_BEHIND_MOVABLE', 'LIMIT_RES_HOLD_TO_STOP_BORROWING_CAP', 'IX_AVAILABLE', 'USE_MIN_CAP_FOR_OVERBOOKING', 'RECALC_REVENUE_WEIGHTED_RHS', 'USE_DB_SPOILAGE_RATIO', 'OVERBOOKING_DOWNWARD_SPILL_MOVABLE', 'CAN_BP_CURVE_GREATERTHAN_OVERBOOKEDCAPACITY', 'OVERBOOKING_DOWNWARD_SPILL_FIXED', 'ENABLE_COMFORT_SEATING', 'OVERBOOKING_BEHIND_FIXED', 'USE_IX_PNR_NO_SHOW', 'NESTING_TYPE', 'AVAIL_ACTION_SEQUENCE', 'GROSS_OR_NET_COMP_FARE', 'FORECAST_GROUP_DEMAND', 'SEASONALITY_SEPARATE_PROFILES_BY_DOW', 'UNTRUNCATION_USE_CLASS_HIERARCHY', 'UNTRUNCATE_MAPPED_BOOKINGS', 'DEFAULT_CONTROL_TYPE', 'FIM_ENABLE_POS_PROCESSING', 'MANUALLY_CONTROLLED_DFLT', 'DEFAULT_MANUAL_CONTROL_INDICATOR', 'STRATEGY_DOMAIN_LEVEL', 'CAP_AVAIL_BY_NEGATIVE_RESHOLD', 'FIM_AVG_FARE_METHOD', 'DUAL_INITIALIZATION_METHOD', 'DYNAMIC_PRICING_OW_RECOM_SHOPPPING', 'DYNAMIC_PRICING_OW_RECOM_COMPFARE', 'EXTRACT_FORMAT_SINGLE_READING_DAY_PER_LINE', 'ROM_WEEK_END_DOW', 'TIMINGS_ENABLED', 'BP_FORWARD_LOWER_THRESHOLD_REF_MIN_BP', 'DYNAMIC_PRICING_USE_AVAILABILITY_COLLECTION', 'DYNAMIC_PRICING_PPS_ADJ_REM_SEAT_CALCULATION', 'DYNAMIC_PRICING_PPS_ADJ_LF_CALCULATION', 'DYNAMIC_PRICING_DIRECTIONAL_PPS_STRATEGY', 'IGNORE_INBOUND_SEASONALITY', 'DYNAMIC_PRICING_CALCULATE_DPADJ_ONLY_FOR_ATPCO_FARES', 'DYNAMIC_PRICING_EXCLUDE_MIX_CLASS_ON_DIRECTION', 'FO_DISTRIBUTION_EMAIL_ID', 'DYNAMIC_PRICING_YIELD_ALL_POSES_CONTROL', 'DYNAMIC_PRICING_USE_BP_IN_EFF_FARE_CHG_CALC', 'DYNAMIC_PRICING_USE_BP_EFF_FARE_CHG_ONLY_OPEN_CLASS', 'INPUT_FOR_LOAD_FACTOR', 'DYNAMIC_PRICING_VM_INCLUDE_PROG_REMOVAL_CLOSURE', 'DYNAMIC_PRICING_VM_PNR_SOURCE_TIMEZONE', 'DYNAMIC_PRICING_FARE_BRAND_IDENTIFICATION', 'DYNAMIC_PRICING_COMPFARE_ITIN_SELECTION', 'DYNAMIC_PRICING_CAP_POSITIVE_ADJUSTMENT', 'DYNAMIC_PRICING_SEASONALITY_TRIGGER_DOW', 'DYNAMIC_PRICING_SEASONALITY_TRIGGER_TIME_UTC', 'DYNAMIC_PRICING_SEASONALITY_TRIGGER_FREQUENCY_WK'];
  var multiSelectDropdownParameterNames = ['ROM_LOCO_PRODUCT_GROUP_INCLUDE', 'FO_FILING_ADMIN_EMAILS', 'FO_HOST_CARRIER', 'FO_VARIABLE_TAX_COMPONENT_USED', 'FO_FARE_COMPONENT_FOR_TFI_APPLICATION'];
  var maskedTimeParameterNames = ['TIME_BEFORE_DEPARTURE_WITH_NO_DEMAND', 'ELAPSED_TIME_BUFFER'];
  var percentParameterNames = ['TRAFFIC_SMOOTH_PERCENT', 'MAX_CLOSE_PCNT_WHEN_INC_BKNGS', 'MAX_CLOSE_PCNT_FOR_ALL_OPEN', 'MIN_HOST_SHARE', 'MAX_HOST_SHARE', 'FIM_MDC_COMPRESSION_PCT', 'INVENTORY_FILE_SIZE_THRESHOLD_PERCENT', 'TRIPSUMMARY_FILE_SIZE_THRESHOLD_PERCENT', 'COMP_FARE_BY_INDEX_THRESHOLD', 'MAX_SHOWUP_RATE', 'MIN_SHOWUP_RATE', 'MAX_FARE_RATIO', 'MIN_FARE_RATIO', 'SHOWUP_RATE_PARAM_A', 'SHOWUP_RATE_PARAM_B', 'ROM_MIN_SURVIVAL_RATE', 'RES_SPILL_THRESHOLD', 'COMFORT_SEATING_MODE_LF_THRESHOLD', 'ROM_LOCO_OPEN_PCT_THRESHOLD', 'DEFAULT_OVERBOOKING_PERCENTAGE', 'DEFAULT_CANCELLATION_RATE', 'DEFAULT_BOARDING_RATE', 'CONVERGENCE_COST_THRESHOLD_UPPER_BOUND'];
  var notEditableParameterNames = ['INVENTORY_TIME_BAND_IN_MINS', 'ROM_RTPS', 'REVENUE_METRICS_INCLUDE_GROUP_BOOKINGS', 'DEFAULT_SIGNIFICANT_MARKET_INDICATOR', 'UNTRUNCATION_NUMBER_OF_WEEKS_IN_ROLLING_WINDOW', 'DEFAULT_OBSERVED_ROUTE_SCORE', 'INCREMENTAL_SCORE_OBSERVED_ROUTE', 'DECREMENTAL_SCORE_OBSERVED_ROUTE', 'MIN_SCORE_OBSERVED_ROUTE', 'HOST_CARRIER', 'DYNAMIC_PRICING_RECOM_FREQUENCY', 'DYNAMIC_PRICING_RECOM_DATAPULL', 'DYNAMIC_PRICING_RECOM_DATAPULL_COMPFARE', 'DYNAMIC_PRICING_RECOM_STARTTIME_UTC'];
  var datetimeParameterNames = ['SEASONALITY_END_DATE', 'SEASONALITY_START_DATE', 'LAST_ROM_DATE'];
  var invisibleParameterNames = ['AUTOAPPROVED_USERS', 'LAST_ISOLATED_DATE', 'PROXY_SYSTEM_DATE', 'BOOKINGS_TREND_CORRECTION', 'BOOKINGS_TREND_CORRECTION_BKG_THRESHOLD', 'BOOKINGS_TREND_CORRECTION_MAX_ADJUSTMENT_PERCENT', 'DEMAND_DISTRIBUTION_TYPE', 'MAX_EM_RTP', 'USE_IGNORE_FORECAST_IN_EM', 'DYNAMIC_PRICING_MIN_FARE', 'DYNAMIC_PRICING_NETWORK_TIME_BAND_IN_MINS', 'DYNAMIC_PRICING_COMPFARE_TIME_BAND_IN_MINS', 'DYNAMIC_PRICING_SHOPPING_TIME_BAND_IN_MINS', 'DYNAMIC_PRICING_MAX_CLASS_CLOSURE_MISSING_COMP_FOR_SHOPPING', 'DYNAMIC_PRICING_CREATE_RECOMMENDATION_WHEN_HOST_FARE_IS_HIGHER', 'DYNAMIC_PRICING_CABIN_MISMATCH', 'DYNAMIC_PRICING_FILTER_COMPETITOR_NO_OF_STOPS', 'DYNAMIC_PRICING_FILTER_COMPETITOR_CODESHARE', 'DYNAMIC_PRICING_FILTER_COMPETITOR_MIN_MAX_CONNECT_TIME', 'DYNAMIC_PRICING_FILTER_COMPETITOR_POS_POC', 'DYNAMIC_PRICING_FILTER_COMPETITOR_BLACKOUT', 'DYNAMIC_PRICING_FILTER_COMPETITOR_DTD', 'DYNAMIC_PRICING_SHOPPING_INPUT_PROCESSED_COUNT_THRESHOLD_PERCENT', 'DYNAMIC_PRICING_YIELDFILE_CHK_LOW_RECOMMENDATION', 'DYNAMIC_PRICING_VM_DEPT_DATE_REPORT', 'DYNAMIC_PRICING_SHOPPING_DISPLAY_LIMIT_IN_DAYS', 'DYNAMIC_PRICING_SHOPPING_EXCLUDE_CARRIERS', 'DYNAMIC_PRICING_BUY_DOWN_TIME_BAND_IN_MINS', 'DYNAMIC_PRICING_IS_ORGANIC_SHOPPING', 'TRACK_ID', 'ANGULARTICS_ENABLE', 'DISPLAYABLE_CABIN_SEQUENCE'];
  var featureDrivenFields = {
    'DF_DEMAND_SMOOTHING_ALPHA': 'DIRECT_FORECAST_ENABLE',
    'DF_DEMAND_INIT_OUTLIER_TOLERANCE': 'DIRECT_FORECAST_ENABLE',
    'DF_DEMAND_INIT_MIN_OBS': 'DIRECT_FORECAST_ENABLE',
    'DF_DEMAND_PROCESS_VARIANCE': 'DIRECT_FORECAST_ENABLE',
    'DYNAMIC_PRICING_ML_BP_MIN_THRESHOLD': 'DYNAMIC_AVAILABILITY_ML_MODEL',
    'DYNAMIC_PRICING_ML_EVAL_INTERVAL': 'DYNAMIC_AVAILABILITY_ML_MODEL',
    'DYNAMIC_PRICING_ADJUSTMENT_MIN_BOUND': 'DYNAMIC_PRICING',
    'DYNAMIC_PRICING_ADJUSTMENT_MAX_BOUND': 'DYNAMIC_PRICING',
    'DYNAMIC_PRICING_FARE_BRAND_IDENTIFICATION': 'DYNAMIC_AVAILABILITY_FARE_BRAND',
    'DYNAMIC_PRICING_CAP_POSITIVE_ADJUSTMENT': 'DYNAMIC_PRICING'
  };
  setDPUseAvailabilityFileVisibility();
  function getStrategyDomainLevels() {
    var levels = conditionsAndActionsService.getLevels('optimization');
    var levelsList = {};
    _.forEach(levels, function (level) {
      if (featureToggleService.isDisabled('SPOS') && _.includes(level.label, 'POS')) {
        level.label = _.trimEnd(_.replace(level.label, 'POS', ''));
      }
      levelsList[level.domain] = level.label;
    });
    return levelsList;
  }
  function getDropdownValues(rowPropertyName) {
    switch (rowPropertyName) {
      case 'DISTANCE_UNIT':
        return ['KM', 'MILES'];
      case 'OVERBOOKING_UPWARD_SPILL_MOVABLE':
      case 'OVERBOOKING_DOWNWARD_SPILL_MOVABLE':
      case 'OVERBOOKING_DOWNWARD_SPILL_FIXED':
      case 'OVERBOOKING_UPWARD_SPILL_FIXED':
        return ['ALL', 'GROUPS', 'NOBODY'];
      case 'AVAIL_ACTION_SEQUENCE':
        return ['LINK,CF,HO', 'LINK,HO,CF', 'CF,LINK,HO', 'CF,HO,LINK', 'HO,LINK,CF', 'HO,CF,LINK'];
      case 'NESTING_TYPE':
        return ['NET', 'THRESHOLD'];
      case 'GROSS_OR_NET_COMP_FARE':
        return ['NET', 'GROSS'];
      case 'DEFAULT_CONTROL_TYPE':
        return ['PHYSICAL', 'FINANCIAL'];
      case 'OVERBOOKING_MODEL':
        return ['QOS', 'ECO'];
      case 'PRORATION_EMSR':
        return ['MULTIPLICATIVE_BIDPRICE', 'DISTANCE'];
      case 'ROM_MAX_SELECT_ANALYSIS_WEEKS':
      case 'DYNAMIC_PRICING_SEASONALITY_TRIGGER_FREQUENCY_WK':
        return ['1', '2', '3', '4'];
      case 'ROM_LOCO_PRODUCT_GROUP_INCLUDE':
        return configurationService.getClassGroups();
      case 'STRATEGY_DOMAIN_LEVEL':
        var levelsList = getStrategyDomainLevels();
        return _.values(levelsList);
      case 'PRORATION_DEMAND_WEIGHTED_CER':
        return ['FIRST_CHOICE', 'MWTP', 'AVERAGE'];
      case 'INPUT_FOR_LOAD_FACTOR':
        return ['PHYSICAL_CAPACITY', 'CABIN_AUTHORIZATION'];
      case 'SEASONALITY_SEPARATE_PROFILES_BY_DOW':
        return ['Yes', 'No'];
      case 'DUAL_INITIALIZATION_METHOD':
        return ['BID_PRICE', 'WEIGHTED_OPEN_DEMAND', 'AVERAGE_HIGH_LOW_RATE'];
      case 'ROM_WEEK_END_DOW':
        return ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
      case 'FIM_AVG_FARE_METHOD':
        return ['USE_FBC_TRAFFIC_WEIGHT', 'USE_FBG_TRAFFIC_WEIGHT'];
      case 'DYNAMIC_PRICING_PPS_ADJ_REM_SEAT_CALCULATION':
        return ['TOP_CLASS_AVAIL', 'PHYSICAL_SEAT'];
      case 'DYNAMIC_PRICING_PPS_ADJ_LF_CALCULATION':
        return ['PHYSICAL', 'AUTH'];
      case 'FO_FILING_ADMIN_EMAILS':
      case 'FO_DISTRIBUTION_EMAIL_ID':
        return _.chain(configurationService.getAllUsers()).transform(function (result, current) {
          result.push(current.userId);
        }).uniq().sortBy().value();
      case 'FO_HOST_CARRIER':
        return configurationService.getHostAndSubsidiaryCarriers();
      case 'FO_FARE_COMPONENT_FOR_TFI_APPLICATION':
      case 'FO_VARIABLE_TAX_COMPONENT_USED':
        return FO_BENCHMARK_COMPONENTS;
      case 'DYNAMIC_PRICING_VM_PNR_SOURCE_TIMEZONE':
        return timezones;
      case 'DYNAMIC_PRICING_FARE_BRAND_IDENTIFICATION':
        return ['AFTER', 'BEFORE'];
      case 'DYNAMIC_PRICING_COMPFARE_ITIN_SELECTION':
        return ['CHEAPEST', 'LATEST'];
      case 'DYNAMIC_PRICING_SEASONALITY_TRIGGER_DOW':
        return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      case 'DYNAMIC_PRICING_SEASONALITY_TRIGGER_TIME_UTC':
        return _.range(0, 24).map(_.toString);
      default:
        return ['TRUE', 'FALSE'];
    }
  }
  function isControlTypeDropdown(key) {
    return _.includes(dropdownParameterNames, key);
  }
  function isControlTypeMultiSelectDropdown(key) {
    return _.includes(multiSelectDropdownParameterNames, key);
  }
  function isControlTypeMaskedInput(key) {
    return _.includes(maskedTimeParameterNames, key);
  }
  function isControlTypeDatetime(key) {
    return datetimeParameterNames.indexOf(key) > -1;
  }
  function isPercentProperty(key) {
    return _.includes(percentParameterNames, key);
  }
  function isLevelProperty(key) {
    return key === 'STRATEGY_DOMAIN_LEVEL';
  }
  function isValueEditable(key) {
    return notEditableParameterNames.indexOf(key) === -1;
  }
  function isValueVisible(key) {
    return invisibleParameterNames.indexOf(key) === -1 && hasValidFeature(key);
  }
  function hasValidFeature(key) {
    return !featureDrivenFields[key] || featureToggleService.isEnabled(featureDrivenFields[key]);
  }
  function getMask(rowPropertyName) {
    switch (rowPropertyName) {
      case 'TIME_BEFORE_DEPARTURE_WITH_NO_DEMAND':
      case 'ELAPSED_TIME_BUFFER':
        return '[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9]';
    }
  }
  function getDateTimeSaveFormat(key) {
    return key === 'LAST_ROM_DATE' ? 'DATE_TIME_ISO' : 'DATE_TIME_ISO_WITHOUT_SECONDS';
  }
  function getDateRowsConfig(key) {
    return {
      editFormatString: momentService.FORMAT.MONTH_DAY_YEAR_CALENDAR,
      saveFormatString: getDateTimeSaveFormat(key),
      momentConfig: momentService.FIELD.SYSTEM_CONFIGURATION_DATE
    };
  }
  function setDPUseAvailabilityFileVisibility() {
    var dpUseAvailabilityFileIndexInInvisibleParameters = invisibleParameterNames.indexOf('DYNAMIC_PRICING_USE_AVAILABILITY_COLLECTION');
    if ((featureToggleService.isEnabled('REVENUE_OPTIMIZER') || featureToggleService.isEnabled('AVAILABILITY_FILE')) && featureToggleService.isEnabled('DYNAMIC_AVAILABILITY')) {
      if (dpUseAvailabilityFileIndexInInvisibleParameters !== -1) {
        invisibleParameterNames.splice(dpUseAvailabilityFileIndexInInvisibleParameters);
      }
    } else {
      if (dpUseAvailabilityFileIndexInInvisibleParameters === -1) {
        invisibleParameterNames.push('DYNAMIC_PRICING_USE_AVAILABILITY_COLLECTION');
      }
    }
  }
  function getTimeZoneCodes() {
    return restangular.one('ancillary').one('airport').one('timezone').one('codes').get();
  }
  if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY')) {
    var timezones;
    getTimeZoneCodes().then(function (data) {
      timezones = data.codes;
    });
  }
  return {
    getDropdownValues: getDropdownValues,
    getMask: getMask,
    getDateRowsConfig: getDateRowsConfig,
    getStrategyDomainLevels: getStrategyDomainLevels,
    isControlTypeDropdown: isControlTypeDropdown,
    isControlTypeMultiSelectDropdown: isControlTypeMultiSelectDropdown,
    isControlTypeMaskedInput: isControlTypeMaskedInput,
    isControlTypeDatetime: isControlTypeDatetime,
    isPercentProperty: isPercentProperty,
    isLevelProperty: isLevelProperty,
    isValueVisible: isValueVisible,
    isValueEditable: isValueEditable
  };
};
ConfigurationParametersControlTypeService.$inject = ['MomentService', 'FeatureToggleService', 'ConfigurationService', 'ConditionsAndActionsService', 'Restangular'];
module.exports = ConfigurationParametersControlTypeService;